module.exports = function(bootstrap) {
    bootstrap.directive('stateSelect', function() {		
    	return {
           restrict: 'A',
            scope: {
            	stateSelect: "="
            },
    		template: '<select><option ng-repeat="li in states" value="{{li.value}}">{{li.name}}</option></select>',
    		link: function(scope,element) {
    			scope.states= [
    			       /*{ "name": "Select a state",
						 "value":""
    			       },*/
    			       { "name": "AK",
						 "value":"AK"
    			       },
    			       { "name": "AL",
    			    	 "value": "AL" 
    			       }, 
      			       { "name": "AR",
      			    	 "value": "AR" 
      			       },
      			       { "name": "AZ",
        			   	 "value": "AZ" 
        			   },
      			       { "name": "CA",
      			    	 "value": "CA" 
      			       },
      			       { "name": "CO",
      			    	 "value": "CO" 
      			       },
      			       { "name": "CT",
      			    	 "value": "CT" 
      			       },
      			       { "name": "DE",
      			    	 "value": "DE" 
      			       },
      			       { "name": "FL",
      			    	 "value": "FL" 
      			       },
      			       { "name": "GA",
      			    	 "value": "GA" 
      			       },
      			       { "name": "HI",
      			    	 "value": "HI" 
      			       },
      			       { "name": "IA",
      			    	 "value": "IA" 
        			   },
      			       { "name": "ID",
      			    	 "value": "ID" 
      			       },
      			       { "name": "IL",
      			    	 "value": "IL" 
      			       },
      			       { "name": "IN",
      			    	 "value": "IN" 
      			       },
      			       { "name": "KS",
      			    	 "value": "KS" 
      			       },
      			       { "name": "KY",
      			    	 "value": "KY" 
      			       },
      			       { "name": "LA",
      			    	 "value": "LA" 
      			       },     			       
      			       { "name": "MA",
      			    	 "value": "MA" 
      			       },
      			       { "name": "MD",
      			    	 "value": "MD" 
        			   },
        			   { "name": "ME",
        			   	 "value": "ME" 
        			   },
      			       { "name": "MI",
      			    	 "value": "MI" 
      			       },
      			       { "name": "MN",
      			    	 "value": "MN" 
      			       },
      			       { "name": "MO",
      			    	 "value": "MO" 
      			       },
      			       { "name": "MS",
      			    	 "value": "MS" 
        			   },
      			       { "name": "MT",
      			    	 "value": "MT" 
      			       },
      			       { "name": "NE",
      			    	 "value": "NE" 
      			       },
      			       { "name": "NV",
      			    	 "value": "NV" 
      			       },
      			       { "name": "NH",
      			    	 "value": "NH" 
      			       },
      			       { "name": "NJ",
      			    	 "value": "NJ" 
      			       },
      			       { "name": "NM",
      			    	 "value": "NM" 
      			       },
      			       { "name": "NY",
      			    	 "value": "NY" 
      			       },
      			       { "name": "NC",
      			    	 "value": "NC" 
      			       },
      			       { "name": "ND",
      			    	 "value": "ND" 
      			       },
      			       { "name": "OH",
      			    	 "value": "OH" 
      			       },
      			       { "name": "OK",
      			    	 "value": "OK" 
      			       },
      			       { "name": "OR",
      			    	 "value": "OR" 
      			       },
      			       { "name": "PA",
      			    	 "value": "PA" 
      			       },
      			       { "name": "RI",
      			    	 "value": "RI" 
      			       },
      			       { "name": "SC",
      			    	 "value": "SC" 
      			       },
      			       { "name": "SD",
      			    	 "value": "SD" 
      			       },
      			       { "name": "TN",
      			    	 "value": "TN" 
      			       },
      			       { "name": "TX",
        			   	 "value": "TX" 
        			   },
        			   { "name": "UT",
            			 "value": "UT" 
        			   },
        			   { "name": "VA",
        				 "value": "VA" 
        			   },
        			   { "name": "VT",
        				 "value": "VT" 
        			   },
        			   { "name": "WA",
        				 "value": "WA" 
        			   },
        			   { "name": "WI",
          				 "value": "WI" 
          			   },
          			   { "name": "WV",
          				 "value": "WV" 
          			   },
          			   { "name": "WY",
          				 "value": "WY" 
          			   }
    			];
    		}
    		
    }
});
}